import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useAPISpoolPriceFeed from '../../../../hooks/web3/general/useAPISpoolPrice';
import useClaimableStakingRewards from '../../../../hooks/web3/vault/useClaimableStakingRewards';

const ClaimableStakingEmissions: React.FC = () => {
    const { claimableStakingRewards } = useClaimableStakingRewards();
    const { apiSpoolPriceFeed } = useAPISpoolPriceFeed();

    const spoolAmount = claimableStakingRewards?.spoolRewards['SPOOL'] ?? 0;
    const voSpoolAmount = claimableStakingRewards?.voSpoolRewards['SPOOL'] ?? 0;

    return (
        <Detail
            title={
                <>
                    <span>Your Claimable Staking Emissions</span>
                    <InfoPopUp>
                        <span className='bold'>Your Claimable Staking Emissions:</span>
                        <div className='mt'>
                            <span className='block'>Staking Emissions:</span>
                            <strong className='block'>
                                {formatUSD(spoolAmount || 0)} $SPOOL
                            </strong>
                            <span>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(spoolAmount * apiSpoolPriceFeed || 0)
                                    : '0.00'}
                                )
                            </span>
                        </div>
                        <div className='mt'>
                            <span className='block'>voSPOOL Emissions:</span>
                            <strong className='block'>
                                {formatUSD(voSpoolAmount || 0)} $SPOOL
                            </strong>
                            <span>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(voSpoolAmount * apiSpoolPriceFeed || 0)
                                    : '0.00'}
                                )
                            </span>
                        </div>
                    </InfoPopUp>
                </>
            }
            value={`${formatUSD(spoolAmount + voSpoolAmount || 0)} $SPOOL`}
        />
    );
};

export default ClaimableStakingEmissions;
